<template>
  <div id="login">
    <div class="header">
      <div class="header-left" />
      <img src="../../../static/images/header-content.png" alt class="header-content">
      <div class="header-right" />
    </div>
    <div class="nav">
      <nav-button :function-id="1" />
      <nav-button :function-id="2" />
      <nav-button :function-id="3" @showlogin="showLogin" />
      <nav-button :function-id="4" />
      <nav-button :function-id="5" />
      <nav-button :function-id="6" />
    </div>
    <b-toast id="toast-msg" no-close-button class="toast-msg" static auto-hide-delay="100">
      {{ LoginMsg }}
    </b-toast>
    <transition name="box" mode="out-in">
      <div v-if="!isShowLogin" key="slide" class="slide-show">
        <slide-img :imgs="imgs" class="banner-slideshow" />
      </div>
      <div v-else key="login" class="login-box">
        <login-banner
          :ispassyzm="YZMState"
          @rememberPwd="rememberPwd"
          @login="login"
          @closeLogin="closeLogin"
          @getYZM="getYZM"
          @countDown="countDown"
        />
      </div>
    </transition>
    <div class="banner-title">
      <img src="../../../static/images/xbanner.jpg" alt="banner">
    </div>
    <div class="content">
      <div class="content-left">
        <div class="content-slide-show">
          <slide-img-two v-if="newsImgs.length>0" :imgs="newsImgs" class="banner-slideshow" />
        </div>
        <div class="content-news">
          <div class="content-top">
            <p class="info-title">行业资讯</p>
            <a rel="noopener noreferrer" href="http://www.lyly360.com/news/newsIndex.htm?type=2" target="_blank">更多<img src="../../../static/images/moreicon.png" alt="图标"></a>
          </div>
          <div v-for="(newInfos,index) in news" :key="index">
            <new :info="newInfos" />
          </div>
        </div>
        <div class="content-clinic">
          <div class="content-top">
            <p class="info-title">良医诊所</p>
            <a rel="noopener noreferrer" href="http://www.lyly360.com/hom/lyzs.htm" target="_blank">更多<img src="../../../static/images/moreicon.png" alt="图标"></a>
          </div>
          <div>
            <img src="../../../static/images/clinicbanner.jpg" alt="banner">
          </div>
          <div class="content-clinic-img-layout">
            <div class="content-clinic-list">
              <img src="../../../static/images/clinicimg1.jpg" alt="诊所" @click="changeImg(require('../../../static/images/clinicimg1.jpg'))">
              <img src="../../../static/images/clinicimg2.jpg" alt="诊所" @click="changeImg(require('../../../static/images/clinicimg2.jpg'))">
              <img src="../../../static/images/clinicimg3.jpg" alt="诊所" @click="changeImg(require('../../../static/images/clinicimg3.jpg'))">
              <img src="../../../static/images/clinicimg4.jpg" alt="诊所" @click="changeImg(require('../../../static/images/clinicimg4.jpg'))">
              <img src="../../../static/images/clinicimg5.jpg" alt="诊所" @click="changeImg(require('../../../static/images/clinicimg5.jpg'))">
            </div>
            <div class="content-clinic-img">
              <img :src="chooseImg" alt="选择的诊所">
            </div>
          </div>
        </div>
        <div class="content-college">
          <div class="content-top">
            <p class="info-title">教育学院</p>
            <a rel="noopener noreferrer" href="http://www.lyly360.com/hom/jyxy.htm" target="_blank">更多<img src="../../../static/images/moreicon.png" alt="图标"></a>
          </div>
          <div>

            <video
              class="video"
              poster="../../../static/images/videoImg.png"
              controls="controls"
              preload="preload"
              src="http://dpv.videocc.net/e2135c3aa1/e/e2135c3aa174658edf0917c59b4abece_2.mp4"
            />
          </div>
        </div>
      </div>
      <div class="content-right">
        <div class="content-tiny-program">
          <div class="content-tiny-program-total">良医良药小程序</div>
          <div class="content-tiny-program-size">专业高效优惠的医药采购移动平台</div>
          <div class="content-tiny-program-info">
            <div class="content-tiny-progran-layout">
              <img src="../../../static/images/xcxred.png" alt="icon">
              <span class="red">多重优惠，多场促销，畅销折扣</span>
            </div>
            <div class="content-tiny-progran-layout">
              <img src="../../../static/images/xcxgreen.png" alt="icon">
              <span class="green">操作简单，及时配送，沟通顺畅</span>
            </div>
            <div class="content-tiny-progran-layout">
              <img src="../../../static/images/xcxblue.png" alt="icon">
              <span class="blue-value">商家众多，商品齐全，服务到位</span>
            </div>
          </div>
          <img class="content-tiny-program-banner" src="../../../static/images/xcxbanner.png" alt="banner">
        </div>
        <div class="content-program">
          <p>好医师诊所管家</p>
          <div>
            一款永久免费的医疗行业管理软件<br>
            采用国内成熟、稳定、安全的C/S架构技术<br>
            实现诊所内部数据共享，科室之间无纸化办公<br>
            通过参数配置，满足于各类<br>
            中、小型诊所、门诊、卫生室使用<br>
          </div>
          <div class="content-program-info">
            <img src="../../../static/images/icon.png" alt="icon">
            <div>值得信赖的健康诊所管家</div>
          </div>
          <img src="../../../static/images/programbanner.png" class="content-program-banner" alt="banner">
          <img src="../../../static/images/button1.png" style="cursor:pointer" class="content-program-button" alt="button" @click="toDownload">
        </div>
        <div class="content-insurance">
          <div>
            <img src="../../../static/images/insurancebanner.png" alt="banner">
          </div>
          <div class="content-insurance-title">
            打造奋勇争先的新型   国际化金融保险集团
          </div>
          <div class="content-insurance-name">
            专为广东良医连锁诊所联盟的广大终端会员<br>
            量身订造的险种——“粤良医”
          </div>
          <div class="cotent-insurance-price">
            <img src="../../../static/images/price.png" alt="price">
          </div>
          <div class="content-insurance-info">
            16~65岁可投<br>
            海陆空全方位安全保障！<br>
            医患纠纷导致的三者责任损失补偿费用<br>
            我来赔！
          </div>
          <button class="content-insurance-button" @click="ToInsurance">立即查看 点击详情</button>
        </div>
      </div>
    </div>
    <div class="footer">
      <div class="footer-banner">
        <img src="../../../static/images/footerbanner.png" alt="banner">
      </div>
      <div class="footer-layout">
        <div class="footer-nav">
          <div>
            <p class="size">新手上路</p>
            <p @click="pageTo('message/placeorder')">下单流程</p>
            <p @click="pageTo('message/qualification')">资质自营</p>
            <p @click="pageTo('message/aboutcompany')">关于良医</p>
          </div>
          <div>
            <p class="size">采购帮助</p>
            <p @click="pageTo('message/aftersaleshelp')">售后帮助</p>
            <p @click="pageTo('message/cooperate')">商务合作</p>
            <p @click="pageTo('message/customerservice')">联系客服</p>
          </div>
          <div>
            <p class="size">支付配送</p>
            <p @click="pageTo('message/payhelp')"> 支付帮助</p>
            <p @click="pageTo('message/passprice')">配送运费</p>
            <p @click="pageTo('message/banktransfer')">银行转账</p>
          </div>
        </div>
        <div class="footer-two-code">
          <img src="../../../static/images/service.png" alt="二维码">
        </div>
      </div>

      <div>
        <div>版权所有©清远市嘉兴医药有限公司 | 互联网药品信息服务资格证书编号(粤)-经营性-2022-0473</div>
        <div>ICP主体备案号：<el-link>粤ICP备18092866号</el-link></div>
        <div><el-link>营业执照副本</el-link></div>
      </div>
    </div>
  </div>
</template>
<script>
import slideshowImg from '../item/SlideShowImg'
import slideshowImgTwo from '../item/SlideShowImgTwo'
import LoginBanner from './LoginBanner'
import NavButton from './NavButton'
import New from './New'
import { UserService } from '@/service/UserService'
import { InfoService } from '@/service/InfoService'
export default {
  components: { 'nav-button': NavButton,
    'new': New,
    'slide-img': slideshowImg,
    'login-banner': LoginBanner,
    'slide-img-two': slideshowImgTwo },
  data () {
    return {
      ipAddr: '',
      isRemember: false,
      YZMState: false,
      chooseImg: require('../../../static/images/clinicimg2.jpg'),
      LoginMsg: '',
      news: [],
      isShowLogin: false,
      imgs: [
        {
          left: require('../../../static/images/banner4-01.jpg'),
          right: require('../../../static/images/banner4-03.jpg'),
          content: require('../../../static/images/banner4-02.jpg'),
          toPage: ''
        },
        {
          left: require('../../../static/images/banner24-1.jpg'),
          right: require('../../../static/images/banner24-3.jpg'),
          content: require('../../../static/images/banner24-2.jpg'),
          toPage: ''
        },
        {
          left: require('../../../static/images/banner25-1.jpg'),
          right: require('../../../static/images/banner25-3.jpg'),
          content: require('../../../static/images/banner25-2.jpg'),
          toPage: ''
        },

        {
          left: require('../../../static/images/banner09_01.png'),
          right: require('../../../static/images/banner09_01-03.png'),
          content: require('../../../static/images/banner09_01-02.png'),
          toPage: ''
        },

        {
          left: require('../../../static/images/banner0305_2.jpg'),
          right: require('../../../static/images/banner0305_1.jpg'),
          content: require('../../../static/images/banner0305_3.jpg'),
          toPage: 'http://www.lyly360.com/Investment_Promotion/attract_Investment.html'
        },
        {
          left: require('../../../static/images/banner03_01.png'),
          right: require('../../../static/images/banner03_03.png'),
          content: require('../../../static/images/banner03_01-02.png')
        },
        {
          left: require('../../../static/images/banner04_01.png'),
          right: require('../../../static/images/banner04_03.png'),
          content: require('../../../static/images/banner04_01-02.png'),
          toPage: ''
        }
      ],
      newsImgs: [
        require('../../../static/images/swiperimg0.jpg'),
        require('../../../static/images/swiperimg1.jpg'),
        require('../../../static/images/swiperimg2.jpg')]
    }
  },
  async mounted () {
    this.getNews()
    this.ipAddr = await this.getIpAddress()
  },
  methods: {

    setCookie (c_name, c_pwd, exdays) {
      var exdate = new Date() // 获取时间
      exdate.setTime(exdate.getTime() + 24 * 60 * 60 * 1000 * exdays)
      window.document.cookie = 'userName' + '=' + c_name + ';path=/;expires=' + exdate.toGMTString()
      window.document.cookie = 'userPwd' + '=' + c_pwd + ';path=/;expires=' + exdate.toGMTString()
    },

    rememberPwd (isRemember) {
      this.isRemember = isRemember
      console.log('this.isRemember++++', this.isRemember)
    },
    pageTo (url) {
      window.open(process.env.BASE_URL + 'message.html#' + url)
    },
    getYZM (phone) {
      console.log(typeof (phone))
      console.log('获取验证码+++++++', phone, phone.length)
      // 获取验证码
      if (phone.length === 0) {
        this.LoginMsg = '请输入手机号'
        this.$bvToast.show('toast-msg')
        return
      }
      this.loadYZM(phone)
    },
    loadYZM (phone) {
      var data = {
        phone: phone
      }
      var userService = new UserService(this.$axios)
      userService.loadYZM(data).then(res => {
        console.log('+++++验证码', res)
        if (res === null) {
          this.LoginMsg = '验证码发送失败'
          this.$bvToast.show('toast-msg')
          return
        }
        if (res.code === '1' && res.code !== null) {
          this.LoginMsg = res.msg
          this.$bvToast.show('toast-msg')
          return
        }
        if (res.code === '0' && res.code !== null) {
          this.LoginMsg = '验证码发送成功'
          this.$bvToast.show('toast-msg')
          this.YZMState = true
        }
      })
    },
    countDown () {
      this.YZMState = false
    },

    changeImg (img) {
      this.chooseImg = img
    },
    toDownload () {
      console.log('111111')
      window.open('http://www.lyly360.com/hom/zsrj.htm ')
    },
    ToInsurance () {
      window.open('http://www.lyly360.com/hom/gmbx.htm ')
    },
    makeToast (append = false) {
      this.$bvToast.toast(`账号密码错误`, {
        autoHideDelay: 5000,
        appendToast: append
      })
    },
    closeLogin () {
      this.isShowLogin = false
    },
    showLogin (data) {
      this.isShowLogin = true
    },
    dealBusinessLogin (res) {
      const { content: { type }} = res
      console.log('登录商业入口')
      if (type !== 0) {
        this.$router.push({
          path: 'index'
        })
      } else {
        this.LoginMsg = '请从终端入口登录'
        this.$bvToast.show('toast-msg')
      }
    },
    DealLogin (res, way, data) {
      if (res.code === '0' && res.code !== null) {
        if (this.isRemember) {
          this.setCookie(data.phone, data.pwd, 7)
        } else {
          this.setCookie('', '', -1)// 清空
        }
        // 登录成功后的操作
        switch (way) {
          case 1:
            window.location.href = 'http://localhost:8081/index'
            break
          case 2:
            this.dealBusinessLogin(res)
            break
          case 3:
            window.location.href = 'http://lf.liangyt.cn/hy-mic-syms/index'
            break
        }
      } else {
        // 登录失败后的操作
        this.LoginMsg = res.msg
        this.$bvToast.show('toast-msg')
        // this.makeToast()
      }
    },
    getNews () {
      this.news = []
      this.newsImg = []
      var data = {
        index: 1,
        size: 3,
        type: 1,
        orderBy: 'createTime desc'
      }
      var infoService = new InfoService(this.$axios)
      infoService.loadNews(data).then(res => {
        console.log('+++++res', res)
        res.forEach(newInfo => {
          this.news.push(newInfo)
        })
      })
    },
    getIpAddress () {
      var rs = this.$jsonp('https://apis.map.qq.com/ws/location/v1/ip',
        { output: 'jsonp', key: '5RTBZ-FKJ3O-2QPWV-S2BNK-VKUQF-DSBSY' }).then((res) => {
        console.log(res)
        var tmpAdd = res.result.ad_info.province + res.result.ad_info.city
        console.log(tmpAdd)
        return tmpAdd
      }).catch(err => {
        console.log(err)
      })
      return rs
    },
    login (name, password, isYZMLogin, way) {
      // 登录请求
      var data = {
        phone: name,
        pwd: password
      }
      var uPattern = /^[a-zA-Z0-9_-]{4,16}$/
      if (!uPattern.test(name)) {
        this.LoginMsg = '请输入正确的用户名'
        this.$bvToast.show('toast-msg')
        return
      }
      if (name === '') {
        this.LoginMsg = '请输入用户名'
        this.$bvToast.show('toast-msg')
        return
      }

      if (isYZMLogin) {
        if (password === '') {
          this.LoginMsg = '请输入验证码'
          this.$bvToast.show('toast-msg')
          return
        }
      }
      if (password === '') {
        this.LoginMsg = '请输入密码'
        this.$bvToast.show('toast-msg')
        return
      }
      var userService = new UserService(this.$axios)
      if (way === 1) {
        if (isYZMLogin) {
          // 验证码登录的方法
          userService.loadYZMTerminal(data).then(res => {
            this.DealLogin(res, way)
          })
        } else {
          userService.loadTerminal(data).then(res => {
            this.DealLogin(res, way, data)
          })
        }
      }
      if (way === 2) {
        data.address = this.ipAddr
        console.log(data)
        userService.loadShop(data).then(res => {
          console.log('+++++', res, way)
          this.DealLogin(res, way, data)
        })
      }
      if (way === 3) {
        userService.loadShop(data).then(res => {
          console.log('+++++', res, way)
          this.DealLogin(res, way, data)
        })
      }
    }
  }
}
</script>
<style scoped>
.box-enter-active, .box-leave-active {
 transition: opacity .25s;

}
.box-enter, .box-leave-to{
   opacity: 0;
}
#login {
  background-color: #ffffff;
  text-align: center;
  color: #2c3e50;
  min-width:1200px;
}
.header{
  display: flex;
    width:100%;
    height: 70px;
    background-color: #e62129;

}
.nav{
    display: flex;
    align-items:center;
    justify-content:space-between;
    width: 1200px;
    height: 180px;
    margin: 0 auto;
}
@media only screen and (min-width: 0px) and (max-width: 1500px) {
   #login{
   /* zoom: 0.9; */
   transform-origin:50% 50% 0;
   transform-origin: center top;
  }
.slide-show{
    height: 580px;
    width: 100%;
    margin: 0 auto;
}
.login-box{
    height:630px;
    width: 100%;
    margin: 0 auto;
    background-color: #ffffff;
}
}
@media only screen and (min-width: 1500px) and (max-width: 3000px) {
	.slide-show{
    height: 580px;
    width: 100%;
    margin: 0 auto;
}
.login-box{
    height:630px;
    width: 100%;
    margin: 0 auto;
    background-color: #ffffff;
}
}
.header-left {
  left: 0;
  width: 100%;
  height: 100%;
  background-color: #ffffff;
  background-position: 100% 100%;
  background-repeat: no-repeat;
  background-color: #e62129;
  background-image:url('../../../static/images/header-left.png')
}
.header-right {
    right: 0;
  height: 100%;
  width: 100%;
  background-color: #ffffff;
  background-repeat: no-repeat;
  background-color: #e62129;
  background-image:url('../../../static/images/header-right.png');
}
.header-content{
  margin: 0 auto;
}
.banner-title{
    height: 200px;
    width: 100%;
    margin: 20px auto 0;
    background-color: #ec0d3d
}
.banner-title img{
    width:1201px;
    height: 100%;
}
.content{
    display: flex;
    margin: 20px auto;
    width: 1200px;
}
.content-left{
    width: 760px;

}
.content-right{
    margin-left: 10px;
    width: 430px;
    background-color: #ffffff;
}
.content-slide-show{
    height: 400px;
    width: 100%;
    background-color: aquamarine
}
.info-title{
    width: 250px;
    height: 45px;
    background-color: #e6212a;
    font-size: 18px;
    font-weight: 600;
    color: #ffffff;
    text-align: center;
    line-height: 45px;
    margin-left: 10px;
    border-radius:10px;
}
.content-news{
    height: 590px;
    margin-top: 10px;
    background-color: #f6f6f6;
}
.content-top {
    display: flex;
}
.content-top a{
    margin-left: 444px;
    color: #000;
    font-size: 14px;
    font-weight: 600;
}
.content-top img{
  display: inline-block;
  margin-bottom: 5px;
}
.content-clinic{
    height: 590px;
    margin-top: 10px;
    background-color: #f6f6f6;
}
.content-clinic-list{
    margin-left: 10px;
    width: 170px;
    height: 265px;
    overflow-y:scroll;
    overflow-x: hidden;
    background-color: #ffffff;
}
.content-clinic-list img{
    margin-top: 10px;
    width: 150px;
    height:84px;
}
.content-clinic-img{
    margin-left: 10px;
}
.content-clinic-img img {
  width: 560px;
  height: 265px;
}
.content-clinic-img-layout{
    display: flex;
    margin-top: 10px;
}
.content-college{
    height: 485px;
    margin-top: 10px;
    background-color: #f6f6f6;
}
.content-tiny-program{
    height: 635px;
    background-color:#f6f6f6;
}
.content-tiny-program-total{
    font-size: 36px;
    font-weight: 800;
}
.content-tiny-program-size{
    font-size: 18px;
    font-weight: 700;
}
.content-tiny-program-info{
    margin-top: 10px;
    margin-bottom: 20px;
}
.green{
    font-size: 18px;
   color: #00ae00
}
.blue-value{
    font-size: 18px;
   color: #009dd9
}
.content-tiny-program-banner{
    width: 410px;
    height: 410px;
}
.content-tiny-program-info span{
    display: inline-block;
    margin-left: 10px;
    font-size: 18px;
}
.content-tiny-program-info img{
    height: 25px;
    width: 25px;
    line-height:30px ;
}
.content-tiny-progran-layout{
    line-height: 30px;
}
.content-program{
    height: 790px;
    margin-top: 16px;
    background-color: #f6f6f6;
}
.content-program p{
    font-size: 36px;
    font-weight: 800;
}
.content-program div{
    font-size: 16px;
    font-weight: 600;
}
.content-program-info{
    margin-top: 20px;
    display: flex;
    font-size: 24px;
    color: #82c6fe;
    margin-left: 55px;
}
.content-program-info div{
    font-size: 24px;
    line-height: 36px;
}

.content-program-banner{
    margin-top: 40px;
}
.content-program-button{
  position: relative;
  z-index: 999;
  top: -70px;
}
.content-insurance{
    height: 646px;
    margin-top: 10px;
    background-color: #f6f6f6;
}
.content-insurance-title{
    margin-top: 20px;
    color: #ff0000;
    font-size: 18px;
    font-weight: 700;
}
.content-insurance-name{
    font-size: 14px;
    font-weight: 700;
}
.cotent-insurance-price{
    margin: 20px auto 0px ;
    width: 260px;
    height: 90px;

}
.content-insurance-info{
    margin-top: 20px;
    font-weight: 500;
    font-size: 14px;
}
.content-insurance-button{
    border: 0px solid transparent;
    border-radius:10px;
    widows: 200px;
    height: 60px;
    color: #ffffff;
    text-align: center;
    font-weight: 800;
    background-color: #e62129;
}
.footer{
  width:100%;
  background-color: #F2F2F2
}
.footer-banner{
    width: 100%;
    height: 110px;
    background-color:#e6212a;
}
.footer-banner img {
    height: 100%;
    width: 1200px;
}
.footer-layout{
  margin: 0 auto;
    display: flex;
    width: 1200px;

}
.footer{
    font-weight: 800;
    font-size: 14px;
}
.footer-two-code{
  margin-left:200px;
  margin-top: 30px;

}
.footer-two-code img{
  width: 140px;
    height: 140px;
}
.footer-nav{
  cursor:pointer;
    margin-top: 40px;
    margin-bottom: 20px;
    margin-left: 375px;
    width: 490px;
    display: flex;
    justify-content:space-between;
}
.video{
    width: 740px;
    height: 400px;
    margin: 0px auto 20px;
}
.size{
  cursor:auto;
    font-size: 16px;
}
.toast-msg{
    position: fixed;
    left: 48%;
    top: 500px;
}
p:hover{
  text-decoration:underline
}
.size:hover{
  text-decoration: none
}
</style>
